import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './IndustryStore.css';

const industries = [
  {
    title: 'Construction Industry',
    description: 'Tools, safety gear, materials, and heavy-duty equipment for construction sites of all scales.',
    icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 20h20"/><path d="M5 20V8l7-5 7 5v12"/><path d="M9 20v-4h6v4"/></svg>',
    bg: 'linear-gradient(135deg, #1a2a1a 0%, #2d5a27 100%)',
    href: '/safety-products',
  },
  {
    title: 'Educational Institutions',
    description: 'Lab supplies, office equipment, janitorial products, and IT hardware for schools and colleges.',
    icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>',
    bg: 'linear-gradient(135deg, #1a1a3a 0%, #2d3a8a 100%)',
    href: '/office-supplies',
  },
  {
    title: 'Agriculture & Cultivation',
    description: 'Irrigation systems, agri tools, fertilizer equipment, and protective gear for modern farming.',
    icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2a7 7 0 0 1 7 7c0 5-7 13-7 13S5 14 5 9a7 7 0 0 1 7-7z"/><path d="M8 9h8M12 5v8"/></svg>',
    bg: 'linear-gradient(135deg, #2a1a00 0%, #7a4f00 100%)',
    href: '/safety-products',
  },
  {
    title: 'Call Centre & Office',
    description: 'Headsets, networking gear, UPS systems, ergonomic furniture, and IT infrastructure.',
    icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>',
    bg: 'linear-gradient(135deg, #1a0a2a 0%, #5a2a8a 100%)',
    href: '/computers-accessories',
  },
];

const whyUs = [
  { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>', title: '500+ Brands', desc: 'Curated selection of leading industrial and consumer brands.' },
  { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>', title: 'Pan-India Delivery', desc: 'Over 20,000 serviceable pincodes across India.' },
  { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>', title: 'Bulk Pricing', desc: 'Special B2B pricing and credit terms for businesses.' },
  { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>', title: 'Quality Assured', desc: 'Every product verified for quality and authenticity.' },
];

const IndustryStore: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="industry-store-page">

      {/* ── Hero ────────────────────────────────────────── */}
      <div className="is-hero">
        <div className="is-hero-inner">
          <div className="is-hero-image">
            <div className="is-hero-image-placeholder">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
            </div>
          </div>
          <div className="is-hero-text">
            <div className="badge">B2B Procurement Platform</div>
            <h1>Industry<br /><span>Store</span></h1>
            <p>
              Industrybull serves millions of businesses aligned with manufacturing and production globally. 
              We offer a wide assortment to meet procurement needs across different industrial sectors — 
              streamlining the sourcing process from one trusted platform.
            </p>
            <div className="is-hero-stats">
              <div className="is-hero-stat">
                <div className="is-hero-stat-value">10M+</div>
                <div className="is-hero-stat-label">Products</div>
              </div>
              <div className="is-hero-stat">
                <div className="is-hero-stat-value">500+</div>
                <div className="is-hero-stat-label">Brands</div>
              </div>
              <div className="is-hero-stat">
                <div className="is-hero-stat-value">20K+</div>
                <div className="is-hero-stat-label">Pincodes</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Industry Segments ───────────────────────────── */}
      <div className="is-section">
        <div className="is-section-header">
          <h2>Shop by Industry Segment</h2>
          <p>Tailored procurement solutions for every business vertical</p>
          <div className="underline"></div>
        </div>
        <div className="is-grid">
          {industries.map((ind, idx) => (
            <Link
              key={idx}
              to={ind.href}
              className="is-card"
              style={{ background: ind.bg }}
            >
              <div className="is-card-bg">{ind.icon}</div>
              <div className="is-card-content">
                <h3>{ind.title}</h3>
                <p>{ind.description}</p>
                <div className="is-card-btn">Shop Now →</div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* ── Why Us ──────────────────────────────────────── */}
      <div className="is-why">
        <div className="is-why-grid">
          {whyUs.map((w, idx) => (
            <div key={idx} className="is-why-item">
              <div className="is-why-icon">{w.icon}</div>
              <div className="is-why-title">{w.title}</div>
              <div className="is-why-desc">{w.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── CTA Banner ──────────────────────────────────── */}
      <div className="is-cta">
        <div className="is-cta-inner">
          <div>
            <h2>Ready to Streamline Procurement?</h2>
            <p>Get started with bulk pricing, GST invoices, and dedicated account support.</p>
          </div>
          <Link to="/contact" className="is-cta-btn">Talk to Our Team →</Link>
        </div>
      </div>

    </div>
  );
};

export default IndustryStore;
